import Vue from 'vue'
import VueGallery from 'vue-gallery'
import store from '../vuex/store'
import SdkDocsNavigation from '../components/Sdk/Docs/Navigation'
import { clipboardClass, textCopyEn, textCopyPl } from './clipboard.class'
import { mapState } from 'vuex'
import { ToolsClass } from './tools.class'
import { PiwikClass } from './piwik.class'

const imgSourceDir = '/autopay_sdk_mobile/v'
const linkImgRegexp = /<img\ssrc="\/?images\/[^"]+"[^>]+>/gi
const imgSourceRegexp = /<img\ssrc="([^"]+)"\s.+>/i

class HtmlParserClass {
  constructor () {
    this.imagesArray = null
  }

  prepareHtml (htmlVal) {
    if (!htmlVal) {
      return new Error('No HTML source')
    }
    const imgMatchArray = htmlVal.match(linkImgRegexp) || []
    htmlVal = this.replaceLinksWithGallery(htmlVal, imgMatchArray)
    this.createMarkdownComponent(htmlVal)
  }

  replaceLinksWithGallery (htmlVal, matchArray) {
    this.imagesArray = []
    matchArray.forEach((text, index) => {
      let imgSource = text.match(imgSourceRegexp)[1]
      imgSource = imgSourceDir + store.state.sdk.version + '/' + imgSource
      if (text.indexOf('no-gallery') !== -1) {
        htmlVal = htmlVal.replace(text, '<img src="' + imgSource + '"/>')
        return
      }
      this.imagesArray.push(imgSource)
      htmlVal = htmlVal.replace(text, '<img class="img-responsive img-gallery" src="' + imgSource + '" @click="index = ' + (this.imagesArray.length - 1) + '" />')
    })
    htmlVal += '<gallery :images="images" :index="index" @onopen="open()" @onclosed="close()" @close="index = null" :options="{ closeOnEscape: true, closeOnSlideClick: true }"></gallery>'
    return htmlVal
  }

  createMarkdownComponent (html) {
    Vue.component('markdown', Vue.extend({
      template: '<div>' + html + '</div>',
      data: () => ({
        index: null,
        images: this.imagesArray,
        contentElement: null,
        codeSwitchers: {}
      }),
      components: {
        SdkDocsNavigation,
        'gallery': VueGallery
      },
      computed: {
        ...mapState({
          lang: state => state.sdk.lang,
          device: state => state.sdk.device,
          darkThemeMode: state => state.app.darkThemeMode
        })
      },
      methods: {
        open () {
          this.contentElement.classList.add('galleryOpen')
        },
        close () {
          this.contentElement.classList.remove('galleryOpen')
        },
        sendDownloadEvent (e) {
          const fileHref = e.target.getAttribute('href')
          const fileName = fileHref.match(/\/([^/]+)$/)[1]
          PiwikClass.sendDownloadEvent(fileName, this.device)
        },
        isCopyingAvailable () {
          return clipboardClass.isCopyingAvailable()
        },
        copyText (event) {
          clipboardClass.copyToClipboard(event)
        },
        getButtonText () {
          return this.lang === 'pl' ? textCopyPl : textCopyEn
        }
      },
      created () {
        this.contentElement = document.getElementById('mainContent')
        this.codeSwitchers = ToolsClass.deepCopy(this.$store.state.app.codeSwitchers)
      },
      destroyed () {
        this.$store.commit('setCodeSwitchers', this.codeSwitchers)
      }
    }))
  }
}

export const htmlClass = new HtmlParserClass()
